import { render, staticRenderFns } from "./HandleNotification.vue?vue&type=template&id=e6d7c210"
import script from "./HandleNotification.vue?vue&type=script&lang=js"
export * from "./HandleNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports